import React from "react";

import AuthorImage from "../../../arrow/components/Atoms/AuthorImage";

import "./story-author-images.m.css";

const StoryAuthorImages = ({ authors = [] }) => {
  if (authors.length < 0) {
    return null;
  }

  return (
    <div styleName="wrapper">
      {authors.map((author) => {
        return (
          <div key={author.id} styleName="author-image">
            <AuthorImage author={author} isClickable={true} />
          </div>
        );
      })}
    </div>
  );
};

export default StoryAuthorImages;
